import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { withRouteData } from 'react-static'

import { countProviderModels, formatNumberWithSpaces } from '../utils'
import Breadcrumbs from './Breadcrumbs'

const CountFeature = ({ count, label }) => (
    <div className="numbers__item animate-appear">
        <div className="numbers__value">{formatNumberWithSpaces(count)}</div>
        <div className="numbers__label">
            {label}
            {count > 1 ? 's' : ''}
        </div>
    </div>
)

function uniqueLen(list) {
    const unique = new Set(list || [])
    return unique.size
}

const CountLanguages = ({ provider: { languages } }) => (
    <div className="doc__section">
        <div className="doc__numbers">
            <div className="numbers">
                {Boolean(languages) && (
                    <Fragment>
                        {languages.symmetric &&
                            languages.symmetric.length > 0 && (
                                <CountFeature
                                    count={languages.symmetric.length}
                                    label="language"
                                />
                            )}
                        {languages.lang && languages.lang.length > 0 && (
                            <CountFeature
                                count={languages.lang.length}
                                label="language"
                            />
                        )}
                        {languages.pairs && languages.pairs.length > 0 && (
                            <CountFeature
                                count={languages.pairs.length}
                                label="language pair"
                            />
                        )}
                        {languages.language &&
                            languages.language.length > 0 && (
                                <CountFeature
                                    count={uniqueLen(languages.language)}
                                    label="language"
                                />
                            )}
                        {languages.toscript &&
                            languages.toscript.length > 0 && (
                                <CountFeature
                                    count={
                                        uniqueLen(languages.toscript) *
                                        uniqueLen(languages.fromscript || [])
                                    }
                                    label="language pair"
                                />
                            )}
                    </Fragment>
                )}
                <div className="numbers__item">
                    <div className="numbers__value">1</div>
                    <div className="numbers__label">category</div>
                </div>
            </div>
        </div>
    </div>
)

const Capabilities = ({ provider }) => (
    <div className="doc__section animate-appear">
        <div className="doc__table table-wrapper">
            <table className="doc-table table table--striped table--fixed-layout">
                <tbody>
                    <tr>
                        <td>Integrated</td>
                        <td>{provider.integrated ? 'yes' : 'no'}</td>
                    </tr>
                    <tr>
                        <td>Billing</td>
                        <td>{provider.billable ? 'yes' : 'no'}</td>
                    </tr>
                    <tr>
                        <td>Models</td>
                        <td>{countProviderModels(provider, true)}</td>
                    </tr>
                    {Boolean(provider.price) && (
                        <tr>
                            <td>Price</td>
                            <td>${provider.price}</td>
                        </tr>
                    )}
                    <tr>
                        <td>HTML Support</td>
                        <td>
                            {(provider.format || []).indexOf('html') === -1
                                ? 'no'
                                : 'yes'}
                        </td>
                    </tr>
                    <tr>
                        <td>Bulk Mode</td>
                        <td>{provider.bulk ? 'yes' : 'no'}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
)

const ProviderCapabilities = ({
    slug,
    providersFromAPI,
    prefetchedIntents,
}) => {
    const providersFullInfo = providersFromAPI[slug] || {}
    const { pending } = providersFullInfo
    let response
    if (pending === false) {
        response = providersFullInfo.response || []
    } else {
        response = prefetchedIntents
    }
    const showHeader = response.length > 1
    return response.map((provider, idx) => (
        <Fragment key={idx}>
            {showHeader && <Breadcrumbs intent={provider.intent} />}
            <CountLanguages provider={provider} />
            <Capabilities provider={provider} />
        </Fragment>
    ))
}

function mapStateToProps(state) {
    return {
        providersFromAPI: state.providersFromAPI || {},
    }
}

export default connect(mapStateToProps)(withRouteData(ProviderCapabilities))



// WEBPACK FOOTER //
// /usr/src/app/frontend/src/components/ProviderCapabilities.jsx